<template>
  <section>
    <label
      v-if="label"
      v-text="label"
      class="p-label v-label"
    ></label>
    <ejs-richtexteditor
      v-if="ejsReady"
      ref="rteInstance"
      :enabled="enabled"
      :height="height"
      :toolbarSettings="toolbarSettings"
      v-model="model">
    </ejs-richtexteditor>
  </section>
</template>

<style>
.api {
  width: 55%;
}
.api td {
  padding-right: 100px;
  margin-top: 3px;
}
@media only screen and (max-width: 600px) {
  .api {
    width: 100%;
  }
  .api td {
    display: block;
  }
}
@media only screen and (min-width: 600px) and (max-width: 1000px) {
  .api {
    width: 55%;
  }
}
</style>

<script>
import Vue from 'vue'
import { RichTextEditorPlugin, Toolbar, Link, Image, HtmlEditor, QuickToolbar, Resize } from '@syncfusion/ej2-vue-richtexteditor'

Vue.use(RichTextEditorPlugin)

export default {
  props: {
    value: {
      type: String
    },
    label: {
      type: String
    },
    enabled: {
      type: Boolean,
      default: true
    },
    height: {
      type: Number,
      default: 700
    }
  },

  data () {
    return {
      toolbarSettings: {
        type: 'Expand',
        items: ['Bold', 'Italic', 'Underline', 'StrikeThrough',
          'FontName', 'FontSize', 'FontColor', 'BackgroundColor',
          'LowerCase', 'UpperCase', '|',
          'Formats', 'Alignments', 'OrderedList', 'UnorderedList',
          'Outdent', 'Indent', '|',
          'CreateLink', 'Image', '|', 'ClearFormat', 'Print',
          'SourceCode', 'FullScreen', '|', 'Undo', 'Redo'
        ]
      },
      ejsReady: false
    }
  },

  computed: {
    model: {
      get () {
        return this.value
      },
      set (value) {
        this.$emit('input', value)
      }
    }
  },

  methods: {
    async prepareEditor () {
      this.ejsReady = false
      await Vue.nextTick()
      this.ejsReady = true
      await Vue.nextTick()
    }
  },

  provide: {
    richtexteditor: [Toolbar, Link, Image, HtmlEditor, QuickToolbar, Resize]
  },

  async created () {
    await this.prepareEditor()
    this.$refs.rteInstance.ej2Instances.shiftEnterKey = 'BR'
  }
}
</script>
